export const fieldParams = {
	nr: {
		minValue: '1',
		maxValue: '',
	},
	callingName: {
		maxLength: '60',
	},
	forename: {
		maxLength: '60',
	},
	surname: {
		maxLength: '60',
	},
	socSec: {
		maxLength: '11',
	},
	profession: {
		maxLength: '', // TEXT
	},
	education: {
		maxLength: '40',
	},
	streetAddress: {
		maxLength: '60',
	},
	tel: {
		maxLength: '20',
	},
	tel2: {
		maxLength: '20',
	},
	postalAddress: {
		maxLength: '60',
	},
	country: {
		maxLength: '40',
	},
	iban: {
		maxLength: '42', // 34 + spacing
	},
	bic: {
		maxLength: '11',
	},
	startDate: {
		maxLength: '10',
	},
	language: {
		maxLength: '7',
	},
	professionCodeAccidentInsurance: {
		maxLength: '20',
	},
	supervisor: {
		maxLength: '60',
	},
	idType: {
		maxLength: '250',
	},
	id: {
		maxLength: '80',
	},
	co: {
		maxLength: '80',
	},
	street: {
		maxLength: '80',
	},
	poBox: {
		maxLength: '80',
	},
	postalCode: {
		maxLength: '60',
	},
	postOffice: {
		maxLength: '60',
	},
	countryCode: {
		maxLength: '2',
	},
	countryName: {
		maxLength: '60',
	},
	nationality: {
		maxLength: '60',
	},
	nationalitySecondary: {
		maxLength: '60',
	},
	experienceCode: {
		maxLength: '10',
	},
	salaryValidFrom: {
		maxLength: '',
	},
	salaryValidUntil: {
		maxLength: '',
	},
	memo: {
		maxLength: '',
	},
	email: {
		maxLength: '',
	},
	email2: {
		maxLength: '',
	},
	memoHR: {
		maxLength: '',
	},
	memoSalary: {
		maxLength: '',
	},
	memoEmployee: {
		maxLength: '',
	},
	memoSupervisor: {
		maxLength: '',
	},
	reminderText: {
		maxLength: '',
	},
}

export const getGenderMap = (t) => ({
	M: t('Male', 'Mies'),
	N: t('Female', 'Nainen'),
	O: t('LimitedCompany', 'Osakeyhtiö'),
	Y: t('BusinessId', 'Y-tunnus'),
	K: t('TemporaryId', 'Tilapäinen yksilöintitunnus'),
})
